// To do:
// - 
// 

import React, { useState, useEffect, useCallback } from 'react';
import { Paragraph, Tab, Tabs, Box, Text } from 'grommet';
import { PageHeader, Page, PageContent } from 'grommet';
import { MapTabContent } from '../../components/MapTabContent';
import { AbstractsComp } from './repos/Abstracts';
import { useLocation, useNavigate } from 'react-router-dom';
import './page.css';

export const ArchiveHome = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabTitles = ['abstracts', 'agendas', 'photos', 'explorer'];

  // 👇 Memoize this function so useEffect knows when it's actually changed
  const getTabIdFromUrl = useCallback(() => {
    const match = location.pathname.match(/\/archive\/([a-z-]+)/);
    return match ? match[1] : 'abstracts';
  }, [location.pathname]);

  const [activeArchiveTab, setActiveArchiveTab] = useState(getTabIdFromUrl);

  // Sync state with URL when the location changes
  useEffect(() => {
    const tabIdFromUrl = getTabIdFromUrl();
    setActiveArchiveTab(tabIdFromUrl);
  }, [getTabIdFromUrl]);

  // Update the browser URL when the tab changes
  useEffect(() => {
    navigate(`/archive/${activeArchiveTab.toLowerCase()}`);
  }, [activeArchiveTab, navigate]);

  const activeTabIndex = tabTitles.indexOf(activeArchiveTab);

  return (
    <Page flex="grow" background="background-back">
      <Box
        background="url('/images/hpe-tech-surface.jpg')"
        height={{ min: '140px', max: 'auto' }}
        margin={{ top: 'none' }}
        pad={{ bottom: 'small' }}
        style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <Box margin={{ top: 'none', left: 'large' }} pad={{ horizontal: 'small' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={
              <Text color="white" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>
                Tech Con Archive
              </Text>
            }
            subtitle={'A history of sustained innovation and insights'}
            style={{ color: 'white' }}
            size="medium"
          />
        </Box>
      </Box>

      <PageContent flex="grow" background="background-back" width="80%">
        <Tabs
          activeIndex={activeTabIndex}
          onActive={(index) => setActiveArchiveTab(tabTitles[index])}
          justify="start"
          pad={{ top: 'medium' }}
        >
          <Tab title="Abstracts">
            <AbstractsComp />
          </Tab>
          <Tab title="Agendas">
            <MapTabContent>
              <Paragraph margin="none">Agendas coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Photos">
            <MapTabContent>
              <Paragraph margin="none">Photos coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Explorer">
            <MapTabContent>
              <Paragraph margin="none">Explorer coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
        </Tabs>
      </PageContent>
    </Page>
  );
};
